<template>
    <div aria-live="polite" aria-atomic="true" class="position-relative px-2 px-md-0">
        <button type="button" class="btn btn-link text-white source-button mt-3" @click="toast.show()">Source</button>

        <div ref="el" class="toast shadow-none" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header shadow-none">
                <strong class="me-auto"></strong>
                <button type="button" class="btn-close-source" data-bs-dismiss="toast" aria-label="Close">&nbsp;</button>
            </div>
            <div class="toast-body text-start shadow-none">{{ $t('source-label') }}<br/>{{ content }}</div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'bootstrap'
export default {
    props:  ['content'],
    name:   'SourceButton',
    data () {
        return {
            toast:null
        };
    },
    mounted () {
        this.toast = new Toast(this.$refs.el, { "autohide": false });
    }
};
</script>
